// 🔥 CENTRALIZED ALARM CONFIGURATION (SCALABLE DCS STRUCTURE)


const alarmConfig = {
 
  // =====================================================
  // 🔵 NK-1 WELLHEAD
  // =====================================================

  TT_10101: {
    description: "NK-1 WELL RESERVOIR TEMPERATURE TRANSMITTER",
    unit: "°C",
    fluid: "Gas",
    ranges: {
      LL: 20,
      L: 50,
      H: 250,
      HH: 280
    } 
  }, 

  FIC_10100: {
    description: "NK-1 METHANOL INJECTION FLOW",
    unit: "L/M",   // Liquid chemical
    fluid: "Liquid",
    ranges: {
      LL: 0.05,
      L: 1.5,
      H: 9,
      HH: 10
    }
  },

  FIC_10102: {
    description: "NK-1 CORROSION INHIBITOR FLOW",
    unit: "L/M",   // Liquid chemical
    fluid: "Liquid",
    ranges: {
      LL: 0.05,
      L: 1.5,
      H: 9,
      HH: 10
    }
  },

  CHK_101: {
    description: "NK-1 WELLHEAD CHOKE VALVE OPENING",
    unit: "%",
    fluid: "Gas",
    ranges: {
      LL: 10,
      L: 20,
      H: 75,
      HH: 90
    }
  },

  

  // =====================================================
  // 🔵 NK-2 WELLHEAD
  // =====================================================

  TT_10201: {
    description: "NK-2 WELL RESERVOIR TEMPERATURE TRANSMITTER",
    unit: "°C",
    fluid: "Gas",
    ranges: {
      LL: 20,
      L: 50,
      H: 250,
      HH: 280
    }
  },

  FIC_10200: {
    description: "NK-2 METHANOL INJECTION FLOW",
    unit: "L/M",
    fluid: "Liquid",
    ranges: {
      LL: 0.05,
      L: 1.5,
      H: 9,
      HH: 10
    }
  },

  FIC_10202: {
    description: "NK-2 CORROSION INHIBITOR FLOW",
    unit: "L/M",
    fluid: "Liquid",
    ranges: {
      LL: 0.05,
      L: 1.5,
      H: 9,
      HH: 10
    }
  },

  CHK_102: {
    description: "NK-2 WELLHEAD CHOKE VALVE OPENING",
    unit: "%",
    fluid: "Gas",
    ranges: {
      LL: 10,
      L: 20,
      H: 75,
      HH: 90
    }
  },












  // =====================================================
  // 🔵 NK-3 WELLHEAD
  // =====================================================

  TT_10301: {
    description: "NK-3 WELL RESERVOIR TEMPERATURE TRANSMITTER",
    unit: "°C",
    fluid: "LIGHT CRUDE COMPOSITION",
    ranges: {
      LL: 20,
      L: 50,
      H: 250,
      HH: 280
    }
  },

  FIC_10300: {
    description: "NK-3 METHANOL INJECTION FLOW",
    unit: "L/M",
    fluid: "Liquid",
    ranges: {
      LL: 0.05,
      L: 1.5,
      H: 9,
      HH: 10
    }
  },

  FIC_10302: {
    description: "NK-3 CORROSION INHIBITOR FLOW",
    unit: "L/M",
    fluid: "Liquid",
    ranges: {
      LL: 0.05,
      L: 1.5,
      H: 9,
      HH: 10
    }
  },

  CHK_103: {
    description: "NK-3 WELLHEAD CHOKE VALVE OPENING",
    unit: "%",
    fluid: "LIGHT CRUDE COMPOSITION",
    ranges: {
      LL: 10,
      L: 20,
      H: 75,
      HH: 90
    }
  },




  
  // =====================================================
  // 🔵 FIRST STAGE SEPARATOR
  // =====================================================


  LT_12001: {
    description: "FIRST STAGE SEPARATOR CRUDE LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8000,
      HH: 9000
    }
  },

  LT_12002: {
    description: "FIRST STAGE SEPARATOR WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8000,
      HH: 9000
    }
  },





   // =====================================================
  // 🔵 SECOND STAGE SEPARATOR
  // =====================================================

  FIC_14001: {
    description: "SECOND STAGE SEPARATOR CRUDE INLET FLOW TRANSMITTER",
    unit: "BPM",
    fluid: "CRUDE COMPOSITION",
    ranges: {
      LL: 3,
      L: 5,
      H: 280,
      HH: 294
    }
  },


  LT_14001: {
    description: "SECOND STAGE SEPARATOR CRUDE LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8000,
      HH: 9000
    }
  },

  LT_14002: {
    description: "SECOND STAGE SEPARATOR WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8000,
      HH: 9000
    }
  },





  // =====================================================
  // 🔵 THIRD STAGE SEPARATOR
  // =====================================================


  LT_15001: {
    description: "THIRD STAGE SEPARATOR CRUDE LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8000,
      HH: 9000
    }
  },

  LT_15002: {
    description: "THIRD STAGE SEPARATOR WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8000,
      HH: 9000
    }
  },



  // =====================================================
  // 🔵 TEST SEPARATOR
  // =====================================================


  LT_13001: {
    description: "TEST SEPARATOR CRUDE LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8000,
      HH: 9000
    }
  },

  LT_13002: {
    description: "TEST SEPARATOR WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8000,
      HH: 9000
    }
  },

  // =====================================================
  // 🔵 SLUDGE CATCHER
  // =====================================================


  LT_2701: {
    description: "SLUDGE CATCHER CRUDE LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 88000,
      HH: 89000
    }
  },

  LT_2702: {
    description: "SLUDGE CATCHER GAS SCRUBBER CRUDE/WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 88000,
      HH: 89000
    }
  },


  // =====================================================
  // 🔵 CRUDE DEHYDRATOR
  // =====================================================


  LT_18001: {
    description: "CRUDE DEHYDRATOR CRUDE LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 10000,
      HH: 11000
    }
  },

  LT_18002: {
    description: "CRUDE DEHYDRATOR WATER/SLUDGE/SALT LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 10000,
      HH: 11000
    }
  },

  // =====================================================
  // 🔵 LP COMPRESSOR A
  // =====================================================


  LT_17001A: {
    description: "LP COMPRESSOR SUCTION DRUM (A) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 87000,
      HH: 90000
    }
  },

  
  // =====================================================
  // 🔵 LP COMPRESSOR B
  // =====================================================


  LT_17001B: {
    description: "LP COMPRESSOR SUCTION DRUM (B) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 87000,
      HH: 90000
    }
  },

  

  // =====================================================
  // 🔵 MP COMPRESSOR A
  // =====================================================


  LT_18001A: {
    description: "MP COMPRESSOR SUCTION DRUM (A) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 87000,
      HH: 90000
    }
  },

  
  // =====================================================
  // 🔵 LP COMPRESSOR B
  // =====================================================


  LT_18001B: {
    description: "MP COMPRESSOR SUCTION DRUM (B) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 87000,
      HH: 90000
    }
  },

  
  // =====================================================
  // 🔵 HP COMPRESSOR
  // =====================================================


  LT_2001: {
    description: "HP COMPRESSOR SUCTION DRUM LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 87000,
      HH: 90000
    }
  },

  

  // =====================================================
  // 🔵 HP GAS COOLER
  // =====================================================


  LT_2201: {
    description: "HP GAS SWEETENING COOLER LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 37000,
      HH: 39000
    }
  },

  
  // =====================================================
  // 🔵 GAS SWEETENING UNIT
  // =====================================================


  LT_2101: {
    description: "H2S SCAVENGER VESSEL LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8700,
      HH: 9000
    }
  },

  LT_2102: {
    description: "CHEMICAL SCAVENGER VESSEL (STORAGE) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 45700,
      HH: 49000
    }
  },

  

 // =====================================================
  // 🔵 PRE-DEHYDRATION GAS COOLER
  // =====================================================


  LT_4201: {
    description: "DEHYDRATION FEED GAS KNOCKOUT DRUM LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 38000,
      HH: 39000
    }
  },



 // =====================================================
  // 🔵 TEG CONTACTOR
  // =====================================================


  LT_2301: {
    description: "TEG CONTACTOR LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 38000,
      HH: 39000
    }
  },


 // =====================================================
  // 🔵 TEG REBOILER
  // =====================================================


  LT_2701: {
    description: "BBC 0500 BTU/HR REBOILER LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 78000,
      HH: 79000
    }
  },

  LT_2702: {
    description: "SURGE DRUM (TEG REBOILER) LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 128000,
      HH: 129000
    }
  },

  LT_2703: {
    description: "FLASH GAS SEPARATOR (TEG REBOILER) LEVEL TRANSMITTER  FOR TEG",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 128000,
      HH: 129000
    }
  },

  LT_2704: {
    description: "FLASH GAS SEPARATOR (TEG REBOILER) LEVEL TRANSMITTER  FOR LIGHT HYDROCARBONS",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 128000,
      HH: 129000
    }
  },

  LT_2705: {
    description: "STAINLESS STEEL VESSEL (TEG REBOILER) LEVEL TRANSMITTER  FOR CONDENSED HYDROCARBONS",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 128000,
      HH: 129000
    }
  },




   // =====================================================
  // 🔵 GAS EXPORT COMPRESSOR STATION
  // =====================================================


  LT_2501: {
    description: "GAS EXPORT COMPRESSOR KNOCKOUT (K.O) DRUM  LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 97000,
      HH: 99000
    }
  },





   // =====================================================
  // 🔵 DE-OILER UNIT
  // =====================================================


  LT_2801: {
    description: "DE-OILER VESSEL 1 WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 10000,
      HH: 11500
    }
  },

  LT_2802: {
    description: "DE-OILER VESSEL 1 CRUDE LEVEL TRANSMITTER",
    unit: "B",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 10000,
      HH: 11500
    }
  },


  LT_2803: {
    description: "DE-OILER VESSEL 2 WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 10000,
      HH: 11500
    }
  },




  // =====================================================
  // 🔵 HYDROGEN SULPHIDE STRIPPER UNIT
  // =====================================================


  LT_2901: {
    description: "SULPHURIC ACID/HYDROCHLORIC ACID STORAGE TANK LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8500,
      HH: 9500
    }
  },

  LT_2902: {
    description: "SOUR WATER STRIPPER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 48000,
      HH: 49500
    }
  },


  // =====================================================
  // 🔵 SKIM PILE UNIT
  // =====================================================


  LT_2911: {
    description: "SKIM PILE CRUDE LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 8500,
      HH: 9500
    }
  },

  LT_2912: {
    description: "SKIM PILE WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 48000,
      HH: 49500
    }
  },


  // =====================================================
  // 🔵 SUBSEA SETTLEMENT TANK UNIT
  // =====================================================


  LT_2921: {
    description: "SUBSEA SETTLEMENT CRUDE LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 48500,
      HH: 49500
    }
  },

  LT_2922: {
    description: "SUBSEA SETTLEMENT WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 88000,
      HH: 89500
    }
  },



  // =====================================================
  // 🔵 OILY WATER TANK UNIT
  // =====================================================


  LT_2931: {
    description: "OILY WATER TANK CRUDE LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 48500,
      HH: 49500
    }
  },

  LT_2932: {
    description: "OILY WATER TANK WATER LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 48000,
      HH: 49500
    }
  },


  // =====================================================
  // 🔵 VACUUM DEARATOR UNIT
  // =====================================================


  LT_2951: {
    description: "VACUUM DEARATOR LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 148500,
      HH: 149500
    }
  },

  LT_2952: {
    description: "VACUUM DEARATOR LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 48000,
      HH: 49500
    }
  },



  // =====================================================
  // 🔵 SODIUM HYPOCHLORITE GENERATOR
  // =====================================================


  LT_2961: {
    description: "WATER SOFTENER TANKS LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 48000,
      HH: 49500
    }
  },

  LT_2962: {
    description: "WATER TANK LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 48000,
      HH: 49500
    }
  },

  LT_2963: {
    description: "SALT DISSOLVING TANK LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 48000,
      HH: 49500
    }
  },

  LT_2964: {
    description: "SODIUM HYPOCHLORITE TANK LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 98000,
      HH: 99000
    }
  },




  // =====================================================
  // 🔵 CORROSION INHIBITION UNIT
  // =====================================================


  LT_2971: {
    description: "CORROSION INHIBITION MIXING TANK LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 98000,
      HH: 99500
    }
  },

  LT_2972: {
    description: "CORROSION INHIBITION TRANSFER TANK LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 1000,
      L: 1300,
      H: 148000,
      HH: 149500
    }
  },



  // =====================================================
  // 🔵 FLARE
  // =====================================================


  LT_2981: {
    description: "CORROSION INHIBITION MIXING TANK LEVEL TRANSMITTER",
    unit: "L",
    ranges: {
      LL: 2000,
      L: 5300,
      H: 178000,
      HH: 189500
    }
  },

 




};

export default alarmConfig;